<template>
<div 
    class="progress-bar"
    role="progressbar"
    v-bind:aria-valuenow="current" 
    v-bind:aria-valuemin="min" 
    v-bind:aria-valuemax="max"
    v-bind:style="styles"
></div>
</template>

<script>
export default {
    props: {
        current: {
            type: Number,
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        variant: {
            type: String,
            default: 'success',
        },
        is_striped: {
            type: Boolean,
            default: false,
        },
        is_animated: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            styles: {
                width: this.current+'%'
            }
        }
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('bg-'+this.variant)

            if(this.is_striped) {
                _class.push('progress-bar-striped')
            }

            if(this.is_animated) {
                _class.push('progress-bar-animated')
            }

            return _class
        }
    }
}
</script>